import { DEV_CENTER_AUTH0_SIGNUP_URL } from "@hub/services/content/data/content-values";

export default {
  sections: [
    {
      title: {
        text: "Documentation",
        url: "https://auth0.com/docs",
      },
      links: [
        {
          text: "Quickstarts",
          url: "https://auth0.com/docs/quickstarts",
        },
        {
          text: "Auth0 APIs",
          url: "https://auth0.com/docs/api",
        },
        {
          text: "SDK Libraries",
          url: "https://auth0.com/docs/",
        },
        {
          text: "Articles",
          url: "https://auth0.com/docs/articles",
        },
      ],
    },
    {
      title: {
        text: "Resources",
        url: "https://auth0.com/resources",
      },
      links: [
        {
          text: "Code Samples",
          url: "https://developer.auth0.com/resources/code-samples",
        },
        {
          text: "Developer Blog",
          url: "https://auth0.com/blog",
        },
        {
          text: "Videos",
          url: "https://www.youtube.com/auth0",
        },
        {
          text: "Podcast",
          url: "https://identityunlocked.auth0.com/public/49/Identity%2C-Unlocked.--bed7fada",
        },
        {
          text: "Newsletter",
          url: "/newsletter",
        },
        {
          text: "Glossary",
          url: "https://auth0.com/docs/glossary",
        },
      ],
    },
    {
      title: {
        text: "Tools",
        url: "",
      },
      links: [
        {
          text: "Auth0 Lab",
          url: "http://discord.gg/XbQpZSF2Ys",
        },
        {
          text: "OIDC Playground",
          url: "https://openidconnect.net/",
        },
        {
          text: "JWT",
          url: "https://jwt.io/",
        },
        {
          text: "Webauthn",
          url: "https://webauthn.me/",
        },
        {
          text: "SAML Tool",
          url: "https://samltool.io/",
        },
      ],
    },
    {
      title: {
        text: "Community",
        url: "",
      },
      links: [
        {
          text: "Forum",
          url: "https://community.auth0.com/",
        },
        {
          text: "Ambassador Program",
          url: "https://auth0.com/ambassador-program",
        },
        {
          text: "Events",
          url: "/events",
        },
        {
          text: "Support",
          url: "https://support.auth0.com/",
        },
        {
          text: "Apollo Program",
          url: "https://auth0.com/apollo-program",
        },
      ],
    },
    {
      title: {
        text: "Company",
        url: "",
      },
      links: [
        {
          text: "About Us",
          url: "https://auth0.com/about",
        },
        {
          text: "Our Customers",
          url: "https://auth0.com/customers",
        },
        {
          text: "Partners",
          url: "https://auth0.com/partners",
        },
        {
          text: "Careers",
          url: "https://auth0.com/careers",
          label: "We’re hiring!",
        },
        {
          text: "Press",
          url: "https://auth0.com/press",
        },
        {
          text: "Compliance",
          url: "https://auth0.com/security",
        },
        {
          text: "Social Impact",
          url: "https://auth0.com/social-impact",
        },
      ],
    },
    {
      title: {
        text: "GET STARTED",
        url: "",
      },
      links: [
        {
          text: "Sign Up",
          url: DEV_CENTER_AUTH0_SIGNUP_URL,
        },
        {
          text: "Pricing",
          url: "https://auth0.com/pricing",
        },
        {
          text: "Contact Sales",
          url: "https://auth0.com/contact-us",
        },
      ],
    },
  ],
  bottom: {
    rights: `©${new Date().getFullYear()}  Okta, Inc. All Rights Reserved.`,
    links: [
      {
        text: "Status",
        url: "https://status.auth0.com",
      },
      {
        text: "Legal",
        url: "https://www.okta.com/agreements/",
      },
      {
        text: "Privacy",
        url: "https://auth0.com/privacy",
      },
      {
        text: "Terms",
        url: "https://auth0.com/web-terms",
      },
    ],
  },
};
